/* unplugin-vue-components disabled */import { render } from "./Offers.vue?vue&type=template&id=40651a68&scoped=true&ts=true"
import script from "./Offers.vue?vue&type=script&lang=ts"
export * from "./Offers.vue?vue&type=script&lang=ts"

import "./Offers.vue?vue&type=style&index=0&id=40651a68&lang=scss&scoped=true"
import "./Offers.vue?vue&type=style&index=1&id=40651a68&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40651a68"]])

export default __exports__